import actions from "./actions";
import mutations from "./mutation";

export default {
  namespaced: true,
  state: {
    employeeProjects: [],
    tasksByProject: [],
    task: {},
    tableLoading: false,
    currentPage: 1,
    perPage: 5,
    searchQuery: "",
    total: 0,
  },
  actions,
  mutations,
};
